import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "../../lib/api";
import { Btn, Card, Pill, Select } from "../dash/Shell";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export default function AdminTechnicians({ onChange }) {
  const [rows, setRows] = useState([]);
  const [plans, setPlans] = useState([]);
  const [pick, setPick] = useState({});

  const load = () => Promise.all([api.get("/admin/technicians"), api.get("/plans")]).then(([t, p]) => { setRows(t.data); setPlans(p.data.filter((x) => x.id !== "trial")); });
  useEffect(() => { load().catch((e) => toast.error(errMsg(e))); }, []);

  const act = async (fn) => { try { await fn(); await load(); onChange?.(); } catch (e) { toast.error(errMsg(e)); } };

  return (
    <Card title="Technicians" sub="Approve new technicians, verify UPI payment screenshots and activate subscription plans manually." testid="admin-technicians">
      {rows.length === 0 ? <p data-testid="admin-no-technicians" className="text-slate-400 text-sm">No technicians registered yet.</p> : (
        <ul className="space-y-4">
          {rows.map((t) => {
            const s = t.subscription;
            return (
              <li key={t.user_id} data-testid={`admin-tech-${t.user_id}`} className="rounded-2xl border border-white/10 p-5 grid md:grid-cols-12 gap-4 items-start">
                <div className="md:col-span-4 flex gap-3">
                  {t.user?.picture ? <img src={t.user.picture} alt="" className="h-10 w-10 rounded-full border border-white/15" /> : <span className="h-10 w-10 rounded-full bg-gold/10 border border-gold/30" />}
                  <div>
                    <p className="text-white font-medium">{t.user?.name || "—"}</p>
                    <p className="text-slate-400 text-xs">{t.user?.email}</p>
                    <p className="text-slate-500 text-xs">{t.phone || "no phone"}</p>
                    <div className="flex flex-wrap gap-1.5 mt-2">{t.services.map((x) => <Pill key={x}>{x}</Pill>)}</div>
                  </div>
                </div>
                <div className="md:col-span-3 text-sm space-y-1.5">
                  <div className="flex gap-2"><Pill tone={t.approved ? "mint" : "gold"} testid={`admin-tech-approved-${t.user_id}`}>{t.approved ? "approved" : "not approved"}</Pill><Pill tone={s.status === "active" ? "mint" : s.status === "trial" ? "gold" : "red"}>{s.status}</Pill></div>
                  <p className="text-slate-400 text-xs">Plan: <span className="text-white capitalize">{s.plan}</span> · till {fmt(s.expires_at)}</p>
                  {s.requested_plan && (
                    <p className="text-mint text-xs">Requested: <span className="capitalize">{s.requested_plan}</span>
                      {s.proof_file_id && <> · <a data-testid={`admin-tech-proof-${t.user_id}`} className="underline" href={fileUrl(s.proof_file_id)} target="_blank" rel="noreferrer">view proof</a></>}
                    </p>
                  )}
                </div>
                <div className="md:col-span-5 flex flex-wrap gap-2 items-center justify-end">
                  <Btn variant="ghost" data-testid={`admin-tech-toggle-approve-${t.user_id}`} onClick={() => act(() => api.patch(`/admin/technicians/${t.user_id}`, { approved: !t.approved }))}>
                    {t.approved ? "Revoke" : "Approve"}
                  </Btn>
                  <Select data-testid={`admin-tech-plan-${t.user_id}`} className="w-auto py-2" value={pick[t.user_id] || s.requested_plan || "monthly"} onChange={(e) => setPick((p) => ({ ...p, [t.user_id]: e.target.value }))}>
                    {plans.map((p) => <option key={p.id} value={p.id}>{p.name.en} ₹{p.price}</option>)}
                  </Select>
                  <Btn data-testid={`admin-tech-activate-${t.user_id}`} onClick={() => act(() => api.post(`/admin/technicians/${t.user_id}/activate`, { plan: pick[t.user_id] || s.requested_plan || "monthly" }))}>Activate</Btn>
                  {s.requested_plan && <Btn variant="danger" data-testid={`admin-tech-reject-${t.user_id}`} onClick={() => act(() => api.post(`/admin/technicians/${t.user_id}/reject-request`))}>Reject</Btn>}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
